import React, { Suspense, createContext, useEffect, useState } from "react"
import { Routes, Route } from "react-router-dom"
import { Skeleton } from "antd-mobile"
import config, { iRouter } from "./pages/config"
// import "./bigDats"
import "./App.scss"
export const Context = createContext({
  logined: false,
  setLogined: (x: boolean) => {},
  showLogin: true,
  setShowLogin: (x: boolean) => {},
})

let appAction: any
function isDouyinMiniProgram() {
  const userAgent = navigator.userAgent;
  // 抖音小程序的 userAgent 中通常包含 "ToutiaoMicroApp" 或 "DouyinMicroApp"
  return userAgent.includes("ToutiaoMicroApp") || userAgent.includes("DouyinMicroApp");
}

function App() {
  const [logined, setLogined] = useState(!!sessionStorage.token)
  const [showLogin, setShowLogin] = useState(true)
  appAction = { setLogined, setShowLogin }

  const title = config.find(
    (page) => page.url.replace(/\//gi, "") === window.location.pathname.replace(/(\/|h5)/gi, ""),
  )?.title
  title && (document.title = title)
  useEffect(() => {
    // 路由拦截逻辑
    if (isDouyinMiniProgram() && !window.location.pathname.includes('h5/page-warning')) {
      window.location.href="/h5/page-warning"; // 跳转到 page-warning 页面
    }
  }, [window.location.pathname]);

  return (
    <div className="App">
      {/* <React.StrictMode> */}
      <Context.Provider value={{ logined, setLogined, showLogin, setShowLogin }}>
        <Suspense
          fallback={
            <div style={{ padding: "10px" }}>
              <Skeleton.Title animated />
              <Skeleton.Paragraph lineCount={5} animated />
              <Skeleton.Title animated />
              <Skeleton.Paragraph lineCount={8} animated />
            </div>
          }
        >
          <Routes>
            {treeRoute(config)}
            <Route
              path="*"
              element={
                <div style={{ margin: "30vh auto", textAlign: "center" }}>
                  <img
                    src="https://staticscdn.zgzpsjz.com/new_yupao_h5/images/why/error404.png"
                    width={140}
                    alt="404"
                  />
                  <p>很抱歉，页面丢失了</p>
                </div>
              }
            />
          </Routes>
        </Suspense>
      </Context.Provider>
      {/* </React.StrictMode> */}
    </div>
  )
}
export { appAction }

/**
 * @author 王鹏
 * @param arrs 路由配置
 * @return {JSX.Element[]} 路由视图Route树
 * @description 输出路由视图树
 */
function treeRoute(arrs: iRouter[]) {
  let DefaultRoute: React.LazyExoticComponent<() => JSX.Element>
  const out = arrs.map((item, index: number) => {
    if (item.children) {
      DefaultRoute = item.children[0].content
    }
    return (
      <Route key={index} path={item.url} element={item.content && <item.content />}>
        {item.children && <Route index element={<DefaultRoute />} />}
        {item.children && treeRoute(item.children)}
      </Route>
    )
  })
  return out
}
export default App
